export enum CalendarSourceType {
    GOOGLE = "Google",
    APPLE = "Apple",
}